module.exports = __webpack_public_path__ + "static/media/MA.aea8894a.png";